import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const QuestionActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

QuestionActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

QuestionActions.defaultProps = {
  basePath: '',
  data: {},
};

export default QuestionActions;
